export default __webpack_public_path__ + "static/media/UBCCounsellingService.416a5cee.png";